class LocationInfo
{
    readonly id: string;
    name: string;
    enabled: boolean;
    gps_coords?: {
        lat: number;
        lng: number;
    };


    constructor(data: any) {
        if (!data) {
            throw "Null data for LocationInfo";
        }
        this.id = data.id;
        this.name = data.name ? data.name : this.id;
        this.enabled = !(data.enabled === false)
        if (data.gps_coords) {
            let tokens = data.gps_coords.split(' ');
            this.gps_coords = { lat: +tokens[0],
                                lng: +tokens[1] };
        }
    }

}

export default LocationInfo;
